import React from 'react';
import { Link } from 'gatsby';

import SocialList from './SocialList';
import Container from './Container';

const Footer = () => {
  return (
    <footer>
      <Container>
        <div className="items-wrapper medium-font">
          <Link to="#intro">home</Link>
          {/* <Link to="/">about us</Link> */}
          <Link to="#Features">features</Link>
          <Link to="https://screenapp.io/blog/guides.html" target="blank">guide</Link>
          <Link to="https://screenapp.io/#/privacy-policy" target="blank">privacy policy</Link>
          <Link to="https://screenapp.io/#/terms-and-conditions" target="blank">terms and conditions</Link>
        </div>
        <div className="social-list-wrapper">
          <SocialList />
        </div>
        <p className="small-font">
          © 2018 - {new Date().getFullYear()} ScreenApp.IO. All Rights Reserved.
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
